import React from 'react'

function CardImage({ dataImage1, dataImage2, dataImage3, dataImage4 }) {
    const image = [dataImage1, dataImage2, dataImage3, dataImage4];
    return (
        image.map((img) => {
            return (
                <div className="flex justify-center">
                    <img src={img} className="w-full pr-2" alt="" />
                </div>
            )
        })
    )
}

export default CardImage